import  axios  from 'axios';
class CommonService {
	async sendMail(body) {
		var mailResponse  = await axios.post('https://api.iddigital.com.au/api/v1/common/sendMail', body)
		return mailResponse;
    }

}
export default CommonService;